import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getPrizeLottery = (params) => {
    return axios.get(`${backendHost}/api/admin/lottery/prize`, {params});
};

export {
    getPrizeLottery
}